import React from "react";

const PortfolioItemForm = ({ item, onChange, onRemove }) => {
  const handleField = (field, value) => onChange({ ...item, [field]: value });

  return (
    <div className="portfolioItemForm">
      <input
        type="text"
        className="portfolioItemForm__title"
        placeholder="タイトル（例: ○○プロジェクト）"
        maxLength={100}
        value={item.title}
        onChange={(e) => handleField("title", e.target.value)}
      />
      <textarea
        className="portfolioItemForm__description"
        placeholder="説明（最大500字）"
        maxLength={500}
        value={item.description}
        onChange={(e) => handleField("description", e.target.value)}
      />
      <button type="button" className="portfolioItemForm__remove" onClick={onRemove}>
        削除
      </button>
    </div>
  );
};

export default PortfolioItemForm;
